/**
 * Renders either an <a> tag if link should open in new tag
 * or a Gatsby <Link> if not
 */

import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'

// styled components
const StyledA = styled.a`
  color: ${({ theme }) => theme.links};
  &:hover {
    text-decoration: underline;
  }
`
const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.links};
  &:hover {
    text-decoration: underline;
  }
  &.active {
    font-weight: 600;
  }
`

interface BasicLinkProps {
  url: string
  openInNewTab?: boolean
  activeClassName?: string
  className?: string
  children: React.ReactNode
}

const BasicLink = ({
  url,
  openInNewTab = false,
  activeClassName,
  className,
  children,
}: BasicLinkProps): JSX.Element => {
  return openInNewTab ? (
    <StyledA target="_blank" href={url} className={className}>
      {children}
    </StyledA>
  ) : (
    <StyledLink
      activeClassName={activeClassName}
      to={url}
      className={className}
    >
      {children}
    </StyledLink>
  )
}
export default BasicLink
